<template>
    <v-form
        ref="form"
        @submit.prevent="onSubmit">
            <v-container fluid>
                <v-row>
                    <v-col cols="12" lg="6">

                        <v-subheader class="text-h6 font-weight-bold px-0 mt-4 mb-2">
                            Error Fallback Settings
                        </v-subheader>

                        <v-switch
                            v-model="form.use_custom_fallback"
                            label="Enable Error Fallback"
                            color="primary"
                            class="mt-0"
                            dense>
                        </v-switch>

                        <v-text-field
                            v-model="form.title"
                            label="Title">
                        </v-text-field>

                        <v-text-field
                            v-model="form.description"
                            label="Description">
                        </v-text-field>

                        <v-text-field
                            label="Price"
                            v-model="form.price"
                            type="number"
                            class="mb-5">
                        </v-text-field>


                        <v-subheader class="text-h6 font-weight-bold px-0 mt-4 mb-2">
                            Invalid Suburb/Postcode Fallback Settings
                        </v-subheader>

                        <v-switch
                            v-model="form.invalid_loc_fallback_settings.enabled"
                            label="Enable Invalid Suburb/Postcode Fallback"
                            color="primary"
                            class="mt-0"
                            dense>
                        </v-switch>

                        <v-text-field
                            v-model="form.invalid_loc_fallback_settings.title"
                            label="Title">
                        </v-text-field>

                        <v-text-field
                            v-model="form.invalid_loc_fallback_settings.description"
                            label="Description">
                        </v-text-field>

                        <v-text-field
                            label="Price"
                            type="number"
                            v-model="form.invalid_loc_fallback_settings.price">
                        </v-text-field>

                        <div class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn :disabled="isSaving" small type="submit" color="primary">
                                <span v-if="isSaving">
                                    <v-progress-circular
                                        indeterminate
                                        size="12"
                                        width="2"
                                        color="primary darken-3">
                                    </v-progress-circular>
                                    Saving..
                                </span>
                                <span v-else>Save Settings</span>
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>

            </v-container>
    </v-form>
</template>

<script>

import { EventBus } from '@/js/event-bus.js'

const target = '/api/live-rates/settings/fallback';

export default {


    props: {
        id: { type: Number, default: null },
    },


    data() {
        return {
            form: {

                use_custom_fallback: false,
                invalid_loc_fallback_settings: {
                    title: 'INVALID SUBURB/POSTCODE',
                    description: 'Please check address spelling and try again',
                    enabled: false,
                    price: ''
                },
                price: 0,
                title: '',
                description: ''
            },
            isSaving: false
        }
    },

    created() {
        this.fetchFallbackSettings();
    },

    methods: {
        onSubmit() {

            this.isSaving = true;
            this.$http
                .post(`${target}/${this.id}`, this.form)
                .then(({ data }) => {
                    EventBus.$emit('show-success', 'Settings updated successfully.')
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                }).finally(() => {
                    this.isSaving = false
                });
        },

        fetchFallbackSettings() {

            this.isSaving = true

            this.$http
                .get(`${target}/${this.id}`)
                .then(({ data }) => {
                    this.form = { ...this.form, ...data.data.quote, ...data.data.fallback_settings };
                    this.form.use_custom_fallback = data.data.use_custom_fallback ?? false;
                    this.form.invalid_loc_fallback_settings = {...this.form.invalid_loc_fallback_settings, ...data.data.invalid_loc_fallback_settings ?? {}};
                }).catch(err => {
                    EventBus.$emit('show-error', err);
                }).finally(() => {
                    this.isSaving = false
                });
        },
    },


}

</script>
